/* eslint-disable default-param-last */
import { UPDATE_MEMBER_ID } from "../actions/memberActions";

const initialMemberState = {
  memberId: localStorage.getItem("memberId") || "",
};

const memberReducer = (state = initialMemberState, action) => {
  switch (action.type) {
    case UPDATE_MEMBER_ID:
      return {
        ...state,
        memberId: action.payload,
      };
    default:
      return state;
  }
};

export default memberReducer;
